import {FC, useMemo, useState} from 'react'
import {SubClient} from '../../../../../services/cellcast.v2.types'
import ApiOverview from './ApiOverview'
import ApiTable from './ApiTable'
import CreateToken from '../Modal/CreateToken'

export type ApiWrapperProps = {
  reload: () => void
  isFetching: boolean
  data: SubClient | undefined
}

const ApiWrapper: FC<ApiWrapperProps> = (props) => {
  const {data} = props
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [loadList, setLoadList] = useState<boolean>(true)

  // Modal
  const CreateTokenModal = useMemo(
    () => (
      <CreateToken
        show={showCreateModal}
        handleClose={() => {
          setShowCreateModal(false)
        }}
        userId={data?._id || ''}
        callbackFn={() => {
          setShowCreateModal(false)
          setLoadList(true)
        }}
      />
    ),
    [showCreateModal]
  )

  return (
    <>
      {CreateTokenModal}
      <ApiOverview {...props} setShowCreateModal={setShowCreateModal} />
      <ApiTable reload={loadList} setReload={setLoadList} data={data} />
    </>
  )
}

export default ApiWrapper
